import {
  NgTemplateOutlet,
  NgClass,
  AsyncPipe,
  CurrencyPipe,
  CommonModule,
} from "@angular/common";
import { HttpParams } from "@angular/common/http";
import { Component, inject, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { FuseAlertComponent } from "@fuse/components/alert";
import { API_ROUTE } from "app/api-routes";
import { ApiService } from "app/service/api.service";
import { AppName } from "environments/app-nam.enum";
import { environment } from "environments/environment";
import { TOAST_DURATION } from "app/app-constant";

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = (control.value || "").trim().indexOf(" ") >= 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
@Component({
  selector: "app-role-form",
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSortModule,
    NgTemplateOutlet,
    MatPaginatorModule,
    NgClass,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatRippleModule,
    AsyncPipe,
    CurrencyPipe,
    CommonModule,
    FuseAlertComponent,
    FuseAlertComponent,
    MatChipsModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: "./user-form.component.html",
  styleUrl: "./user-form.component.scss",
})
export class UserFormComponent implements OnInit, OnDestroy {
  // hidePassword = true;
  // hideConfirmPassword = true;
  isIhcl: boolean = false;
  userForm!: FormGroup;
  roles: string[] = ["Maker", "Checker", "Approver", "Assessor"];
  functionalPermissions: string[] = [
    "Permission1",
    "Permission2",
    "Permission3",
  ];
  showAlert = false;
  alert: any = { type: "Error", message: "Something went wrong" };
  isEditMode = false;
  isVendor = false;
  isSubAdmin = false;
  vendorName: string = ""; // Define a class property

  // Search box control for the Role dropdown (ngx-mat-select-search), and the
  // role list filtered against it.
  roleFilterCtrl: FormControl = new FormControl("");
  filteredRoles: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  private _onDestroy = new Subject<void>();

  private _snackBar = inject(MatSnackBar);
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserFormComponent>,
    private _apiSerivce: ApiService,
    private _apiServvice: ApiService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //this.fetchRoles();
    this.isEditMode = !!this.data;
    this.userForm = this.fb.group(
      {
        username: [
          "",
          [
            Validators.required,
            Validators.minLength(3),
            Validators.pattern(/^[a-zA-Z0-9.]+$/),
            noWhitespaceValidator(),
          ],
        ],
        userType: ["user", Validators.required],
        firstName: [
          "",
          [
            Validators.required,
            Validators.pattern(/^[a-zA-Z\s]+$/), // only letters and spaces
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            Validators.pattern(/^[a-zA-Z\s]+$/), // only letters and spaces
          ],
        ],
        email: ["", [Validators.required, Validators.email]],
        phoneNumber: [
          "",
          [ Validators.pattern(/^[0-9]{10}$/)],
        ],
        roleId: ["", Validators.required],

        // Add password fields only for CREATE mode
        ...(this.isEditMode
          ? {}
          : {
              // password: [
              //   "",
              //   [
              //     Validators.required,
              //     Validators.minLength(8),
              //     // Optional: stronger pattern
              //     // Validators.pattern(
              //     //   "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}$"
              //     // ),
              //   ],
              // ],
              // confirmPassword: ["", Validators.required],
            }),
      },
      // Add custom validator only for create mode
      // this.isEditMode ? undefined : { validators: this.passwordMatchValidator }
    );
    if (this.isIhcl) {
      this.userForm.removeControl("phoneNumber");
    }
  }

  // passwordMatchValidator(form: FormGroup) {
  //   const password = form.get("password")?.value;
  //   const confirmPassword = form.get("confirmPassword")?.value;
  //   return password === confirmPassword ? null : { passwordMismatch: true };
  // }
  allowOnlyAlphaNumAndDot(event: KeyboardEvent): void {
    if (!/^[a-zA-Z0-9.]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    if (this.data) {
      this.isVendor = this.data?.userType === "vendor"; // Check if userType is vendor
      console.log(this.data);
      // Store vendor name separately
      if (this.isVendor) {
        this.vendorName = this.data.vendorName || ""; // Ensure vendorName is set
      }
      this.userForm.patchValue({
        username: this.data.username,
        userType: this.data.userType,
        firstName: this.data.profile?.firstName,
        lastName: this.data.profile?.lastName,
        email: this.data.profile?.email,
        // phoneNumber: this.data.profile?.contactInfo?.phone?.number,
        address: this.data.profile?.contactInfo?.address?.street, // assuming street is the main address field
        lastLogin: this.data.lastLogin,
        roleId: this.data.roleId,
      });
      if (!this.isIhcl) {
        this.userForm.patchValue({
          phoneNumber: this.data.profile?.contactInfo?.phone?.number,
        });
      }

      if (this.isVendor) {
        this.userForm.get("roleId")?.disable();
      }

      if (this.data?.userType === "sub-admin") {
        this.isSubAdmin = true;
        this.userForm.get("roleId")?.disable();
        this.userForm.get("roleId")?.clearValidators();
        this.userForm.get("roleId")?.updateValueAndValidity();
      }
    }
    const params = new HttpParams().set("skip", 1).set("limit", 100);

    this._apiSerivce.get(API_ROUTE.ROLE.getAllForDropDown).subscribe({
      next: (res: any) => {
        this.roles = res.data;
        this.filteredRoles.next(this.roles.slice());
      },
    });

    this.roleFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => this.filterRoles());

    this._setApp();
  }

  onSubAdminToggle(event: any): void {
    this.isSubAdmin = event.checked;
    const roleIdControl = this.userForm.get("roleId");
    if (this.isSubAdmin) {
      this.userForm.get("userType")?.setValue("sub-admin");
      roleIdControl?.setValue("");
      roleIdControl?.disable();
      roleIdControl?.clearValidators();
    } else {
      this.userForm.get("userType")?.setValue("user");
      roleIdControl?.enable();
      roleIdControl?.setValidators(Validators.required);
    }
    roleIdControl?.updateValueAndValidity();
  }

  onSubmit() {
    if (this.userForm.valid) {
      const formValues = this.userForm.value;
      this.showAlert = false;
      this.showAlert = false;
      // Transform form values to match the desired payload structure
      const userData = {
        username: formValues.username,
        userType: formValues.userType || "user",

        profile: {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          email: formValues.email,
          contactInfo: {
            phone: {
              countryCode: formValues.countryCode || "1",
              number: formValues.phoneNumber,
            },
          },
        },
        ...(!this.isSubAdmin && { roleId: formValues.roleId }),
        // password: this._apiServvice.encryptData(formValues.password),
        // confirmPassword: this._apiServvice.encryptData(
        //   formValues.confirmPassword
        // ),
      };

      if (!this.data?._id) {
        // Call the API to create the user
        this._apiSerivce.post(API_ROUTE.USER.create, userData).subscribe(
          (res: any) => {
            this.dialogRef.close(userData);
            this.openSnackBar(res.msg);
          },
          (err: any) => {
            this.openSnackBar(err.error.msg);
          }
        );
      } else {
        userData["id"] = this.data._id;
        // Call the API to create the user
        this._apiSerivce.put(API_ROUTE.USER.update, userData).subscribe(
          (res: any) => {
            this.dialogRef.close(userData);
            this.openSnackBar(res.msg);
          },
          (err: any) => {
            this.openSnackBar(err.error.msg);
          }
        );
      }
      // Close dialog after submitting
    }
  }

  fetchRoles() {
    this._apiSerivce.get(API_ROUTE.ROLE.getAll).subscribe((res: any) => {
      this.roles = res.data;
      this.filteredRoles.next(this.roles.slice());
    });
  }

  private filterRoles(): void {
    if (!this.roles) return;
    let search = this.roleFilterCtrl.value;
    if (!search) {
      this.filteredRoles.next(this.roles.slice());
      return;
    }
    search = search.toLowerCase();
    this.filteredRoles.next(
      this.roles.filter((role: any) => role.name?.toLowerCase().indexOf(search) > -1),
    );
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string = "") {
    this._snackBar.open(message, action, {
      horizontalPosition: "end",
      verticalPosition: "top",
      duration: TOAST_DURATION,
      panelClass: "app-snackBar",
    });
  }
  _setApp() {
    switch (environment.APP_NAME) {
      case AppName.IHCL:
        this.isIhcl = true;
        break;
    }
  }
}
